import * as types from "./mutation_types";
import Notify from 'quasar/src/plugins/Notify.js';;
import {lostForm} from "@/helpers/lostForm";

export const setScreenVisibility = ({ commit }, screens) => {
  commit(types.SET_FORM_SCREENS_VISIBILITY, screens);
  //console.log('SET_FORM_SCREENS');
};

export const setFieldVisibility = ({ commit }, fields) => {
  commit(types.SET_FORM_FIELDS_VISIBILITY, fields);
  //console.log('SET_FORM_FIELDS');
};
export const setFieldValues = ({ commit }, fields) => {
  commit(types.SET_FORM_FIELDS_VALUES, fields);
  //console.log('SET_FORM_FIELDS_VALUES');
};



// fields get and set
export const updateFieldValue = ({ commit }, {fieldSettings, fieldValue}) => {
  let field = {};
  field[fieldSettings.id] = fieldValue;

  commit(types.UPDATE_FORM_FIELD_VALUE, field);
  //console.log('UPDATE_FORM_FIELD_VALUE');
};

export const updateFieldValueByFieldType = ({ commit }, {form, type, fieldValue}) => {
  for(let key in form.screens) {
    for (let keyF in form.screens[key].fields) {
      const field = form.screens[key].fields[keyF];
      if(type === field.type) {
        updateFieldValue({ commit }, {fieldSettings: field, fieldValue});
      }
    }
  }
};

export const getFieldValue = ({state}, {fieldSettings}) => {
  return state.fieldValues[fieldSettings.id];
}

export const backScreen = ({ commit, state }, {form}) => {
  let nextScreen = state.activeScreen;
  if(state.activeScreen > 0) {
    nextScreen--;
    while (!state.screensVisibility[form.screens[nextScreen].id] && nextScreen > 0) {
      nextScreen--;
    }
    commit(types.SET_SCREEN, parseInt(nextScreen));
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}


export const nextScreen = ({ commit, state }, {form}) => {
  const count = Object.keys(form.screens).length;
  let nextScreen = state.activeScreen;
  if (count > (state.activeScreen + 1)) {
    nextScreen++;
    while (!state.screensVisibility[form.screens[nextScreen].id] && count > (nextScreen + 1)) {
      nextScreen++;
    }

    commit(types.SET_SCREEN, parseInt(nextScreen));
    lostForm(form, state.fieldValues, state.fieldsVisibility, nextScreen);
    if(form.screens[nextScreen].screen_event) {
      try {
        const event =new Function (form.screens[nextScreen].screen_event);
        event();
        if(state.debug) {
          Notify.create('Screen event executed');
        }
      } catch (e) {
        console.log(e);
      }
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}

export const next = ({ commit }) => {
  commit(types.NEXT_SCREEN);
}

export const back = ({ commit }) => {
  commit(types.BACK);
}

export const enableDebug = ({ commit }) => {
  commit(types.ENABLE_DEBUG);
}
export const setLogo = ( {commit}, {logo} ) => {
  commit(types.SET_LOGO, logo);
}

export const setLoanType = ( {commit}, {type} ) => {
  commit(types.SET_LOAN_TYPE, type);
}

export const setPassedParams = ( {commit}, {passed_params} ) => {
  commit(types.SET_PASSED_PARAMS, passed_params);
}

export const setScreen = ( {commit}, {screen} ) => {
  commit(types.SET_SCREEN, parseInt(screen));
}

export const setReviewVisible = ( {commit} ) => {
  commit(types.SET_REVIEW_VISIBLE);
}

export const setReviewScreenIndex = ( {commit}, {index} ) => {
  commit(types.SET_REVIEW_SCREEN_INDEX, index);
}

export const fieldsVisibilityVersionUp = ({ commit }) => {
  commit(types.FIELDS_VISIBILITY_VERSION_UP);
}
export const screensVisibilityVersionUp = ({ commit }) => {
  commit(types.SCREENS_VISIBILITY_VERSION_UP);
}